export default __webpack_public_path__ + "static/media/classical-music.fb25785e.jpg";